import {
  Grid,
  Select,
  Typography,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";
import CustomSwitchText from "../../shared/CustomSwitchText";
import { useEffect, useState } from "react";
const Control = ({ formik, setTouched }) => {
  const handleChange = (e) => {
    setTouched(true);
    formik.handleChange(e);
  };

  const [showOriginal, setShowOriginal] = useState(
    formik.values.controlMode === "NORMAL" ? true : false
  );

  //Show Original handler
  const showOriginalToggler = () => {
    formik.setFieldValue(
      "controlMode",
      showOriginal ? "MAKER_CHECKER" : "NORMAL"
    );
    setTouched(true);
    setShowOriginal(!showOriginal);
  };

  const logSystemOptions = [{ value: "USER_PC", label: "On User PC" }];

  useEffect(() => {
    setShowOriginal(formik.values.controlMode === "NORMAL" ? true : false);
  }, [formik.values.controlMode]);

  return (
    <Grid
      container
      direction="column"
      rowSpacing="16px"
      justifyContent="flex-start"
      sx={{
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #E7E9EF",
        padding: "24px",
      }}
    >
      <Grid item>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
          }}
        >
          Control
        </Typography>

        <CustomSwitchText
          id="controlMode"
          value={formik.values.controlMode}
          checked={!showOriginal}
          onChange={showOriginalToggler}
        />
      </Grid>
      <Grid item>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "5px",
          }}
        >
          Log System
        </Typography>
        <FormControl
          error={formik.touched.logSystem && Boolean(formik.errors.logSystem)}
        >
          <Select
            name="logSystem"
            value={formik.values.logSystem}
            onChange={handleChange}
            inputProps={{ "aria-label": "Without label" }}
            sx={{
              width: "180px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
            }}
            renderValue={(selected) => {
              if (selected === "SELECT LOG SYSTEM") {
                return <em>SELECT LOG SYSTEM</em>;
              }

              return logSystemOptions.find(
                (option) => option.value === selected
              ).label;
            }}
          >
            <MenuItem
              disabled
              value="Log system"
              sx={{ fontSize: ".7rem", height: "10px" }}
            >
              <em>SELECT LOG SYSTEM</em>
            </MenuItem>
            <MenuItem disabled value="SELECT LOG SYSTEM"></MenuItem>
            {logSystemOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {formik.touched.logSystem && Boolean(formik.errors.logSystem) && (
            <FormHelperText>{formik.errors.logSystem}</FormHelperText>
          )}
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default Control;
